import * as React from 'react'
import styled from 'styled-components'

const TextClamp: React.VFC<{
  line: number
  children: string | React.ReactNode
  width?: number
}> = ({ children, line, width }) => {
  return (
    <TextClampWrapper line={line} width={width}>
      {children}
    </TextClampWrapper>
  )
}

const TextClampWrapper = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${({ line }) => line};
  white-space: pre-wrap;
  overflow: hidden;
  ${({ width }) =>
    width &&
    `
    width: 100%;
    max-width: ${width}px;
  `}
`

export default TextClamp
